import React from 'react';
import MasonryGrid from './MasonryGrid';
import { Link } from 'react-router-dom';
import { EastRounded } from '@mui/icons-material';

const HomePromptExample = () => {
      // Isko true rakha hai jaisa tune bola
      const showhome = true;

      return (
            <>
                  <section className="home-prompt-section">
                        <div className="community-body pb-0">
                              <div className="__container">
                                    <div className="text-section text-center-sm-left mb-5">
                                          <h1> See what the community is creating and <br /> loving right now.</h1>
                                          <p className="mt-2">
                                                Every image comes with the exact prompt that created it. Skip the guesswork and learn directly from places that caught the community's attention.
                                          </p>
                                    </div>

                                    {/* Prop pass ho rahi hai yahan */}
                                    <MasonryGrid showhome={showhome} />
                              </div>
                        </div>

                        <div className='__explore-jsd'>
                              <Link className='btn' to="/gallery">
                                    Browse Prompts <EastRounded />
                              </Link>
                        </div>
                  </section>
            </>
      );
}

export default HomePromptExample;